import {VisibilityLevel} from "../Analytics.type";

export const getRolesOptions = (visibilityLevel: VisibilityLevel, intl) => {
  let rv = []
  switch (visibilityLevel) {
    case 1:
      rv = ['field_manager', 'field', 'area_manager', 'agent']
      break
    case 2:
      rv =  ['field', 'area_manager', 'agent']
      break
    default:
      rv =  ['agent']
      break
  }
  return rv.map(role => ({value: role, label: intl.formatMessage({id: `${role}`})}) )
}

export const allUsers = ['registered', 'activated', 'user', 'adopter', 'promoter', 'churn', 'deleted', 'pending', 'never_registered']
export const initUsers = ['registered', 'activated', 'user', 'adopter', 'promoter', 'churn']